module.exports = __webpack_public_path__ + "static/media/bcc.54f680d8.svg";